import palette from '../../theme/palette';

export const chartColors = palette.chart;

export const seriesColor = (index) => chartColors.series[index % chartColors.series.length];

export const axisProps = {
  axisLine: false,
  tickLine: false,
  tick: { fill: chartColors.axis, fontSize: 11, fontFamily: '"Inter Variable", Inter, system-ui, sans-serif' },
};

export const gridProps = {
  stroke: chartColors.grid,
  strokeDasharray: '2 6',
  vertical: false,
};

export const cursorProps = {
  stroke: chartColors.cursor,
  strokeOpacity: 0.45,
  strokeDasharray: '3 3',
};

export const safeId = (id) => String(id).replace(/[^a-zA-Z0-9_-]/g, '');
